export default __webpack_public_path__ + "static/media/AWAYPM.acfd790a.svg";